import { render } from "./questions.vue?vue&type=template&id=338b4b90&lang=pug"
import script from "./questions.vue?vue&type=script&setup=true&lang=js"
export * from "./questions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__